export enum STATUS {
  SUCCESS = 'OK',
  FAILURE = 'KO',
}

export enum SORT_DIRECTION {
  ASC = 1,
  NONE = 0,
  DESC = -1,
}

export const INTERNAL_PROP_PREFIX = '__';
export const EVENT_TOKEN_PROP_PREFIX = '__eventToken__';
export const EVENT_ID_PROP_PREFIX = '__event__';
